// This file is automatically generated during a build, postinstall,
// and can manually be built with `npm run write-chessboard-version-file`

export const CHESSBOARD_VERSION = '1.111.0';
